import { render } from "./DocumentMetadata.vue?vue&type=template&id=10b4102c&scoped=true"
import script from "./DocumentMetadata.vue?vue&type=script&lang=js"
export * from "./DocumentMetadata.vue?vue&type=script&lang=js"

import "./DocumentMetadata.vue?vue&type=style&index=0&id=10b4102c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b4102c"]])

export default __exports__